var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mb-3 x12"},[_c('Loader',{attrs:{"color":"white","text":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }